import { InjectionToken } from '@angular/core';

export interface FtpFileEntry {
  name: string;
  size: number;
  isDirectory: boolean;
}

export interface FtpConnectionConfig {
  host: string;
  port: number;
  /** Always passive — active mode flaked in the Cannes spike. */
  passive: true;
  /** Always anonymous — WPA2 passphrase is the access barrier, not FTP credentials. */
  anonymous: true;
}

export interface FtpTransport {
  connect(config: FtpConnectionConfig): Promise<void>;
  disconnect(): Promise<void>;
  list(remoteDir: string): Promise<Array<FtpFileEntry>>;
  size(remotePath: string): Promise<number>;
  downloadToFile(remotePath: string, localPath: string): Promise<void>;
}

export const FTP_TRANSPORT = new InjectionToken<FtpTransport>('FtpTransport');
